import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { IPropertyCard } from '../../shared/models/propertycard';

/**
 * Encapulates the maps search list component interaction logic
 */
@Component({
  selector: 'map-search-list',
  templateUrl: './map-search-list.component.html',
  styleUrls: ['./map-search-list.component.css']
})
export class MapSearchListComponent implements OnInit {

  @Input() source: IPropertyCard[];
  @Output() textChange = new EventEmitter<any[]>();
  @Output() selected = new EventEmitter<any>();
  @Output() propertyListCount: EventEmitter<any> = new EventEmitter<any>();
  private _searchText: string;
  public get searchText(): string {
    return this._searchText;
  }
  public set searchText(v: string) {
    this._searchText = v;
  }

  /**
   * Gets the location source collection
   */
  public get locations(): IPropertyCard[] {

    this.propertyListCount.emit(this.source.length);
    return this.source;
  }

  private _selectedLocation: IPropertyCard;

  /**
   * Gets the selected location
   */
  public get selectedLocation(): IPropertyCard {
    return this._selectedLocation;
  }

  /**
   * Sets the selected location
   */
  public set selectedLocation(v: IPropertyCard) {
    this._selectedLocation = v;
  }

  constructor() { }

  ngOnInit() {
  }

  onTextChanges($event: any): void {
    this.textChange.emit(this.filterByText());
  }

  /**
   * Fires when a location is selected
   * @param location The selected GeoJson property
   */
  onSelectLocation(location: any): void {
    this.selectedLocation = location;
    this.selected.emit(this.selectedLocation);
  }

  private filterByText(): any[] {
    if (!this.locations) { return []; }

    if (!this.searchText) { return this.locations; }

    this.searchText = this.searchText.toLowerCase();

    return this.locations.filter(it => {
      return it.PropertyName.toLowerCase().includes(this.searchText);
    });
  }
}
